export default __webpack_public_path__ + "static/media/nodata.6d71b9c3.png";